import { createFileRoute } from "@tanstack/react-router"

import { OrgChart } from "@/pages/OrgChart"

export const Route = createFileRoute("/org-chart")({
  component: OrgChart,
})
